import type { ImageValue } from '@elfsight/configurator-contracts';
import type { BackgroundType, ColorScheme } from '../../types';

export const getBackgroundStyle = (
  colorScheme: ColorScheme,
  backgroundType: BackgroundType,
  backgroundColor: string,
  backgroundImage: ImageValue,
  backgroundImageOverlayColor: string | null
) => {
  if (colorScheme === 'dark') {
    return `
      background-color: #000;
    `;
  }

  if (colorScheme === 'light') {
    return `
      background-color: #fff;
    `;
  }

  if (backgroundType === 'color') {
    return `
      background-color: ${backgroundColor};
    `;
  }

  if (backgroundType === 'image' && colorScheme === 'custom') {
    return `
      background-image: url('${backgroundImage?.url}');
      background-position: center;
      background-size: cover;

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-color: ${backgroundImageOverlayColor};
        z-index: 0;
        border-radius: inherit;
      }
    `;
  }

  return `
    background-color: transparent;
  `;
};
